import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {useWorkspace} from '../hooks/useWorkspace';
import {workspacePath} from '../services/paths.js';
import {dataClient} from '../data/dataClient';

const {FiCalendar, FiLink, FiBot, FiUser, FiFileText} = FiIcons;

export function PlanCard({plan, bot}) {
  const state = useWorkspace();
  const dest = workspacePath(plan.module || 'finance', state);

  return (
    <article className="plan-card">
      <div className="inline spread">
        <span className={`status ${plan.status}`}>{plan.status}</span>
        <small>v{plan.version || 1}</small>
      </div>
      <h3>
        <Link to={dest} className="plan-card-link">
          {plan.title}
        </Link>
      </h3>
      <p>
        <SafeIcon icon={FiFileText} /> {plan.module} · {bot?.name || 'Lead'}
      </p>
    </article>
  );
}

export function TaskCard({task, plan, onStatusChange}) {
  const state = useWorkspace();
  const dest = plan ? workspacePath(plan.module || 'finance', state) : null;

  async function handleCycleStatus() {
    const nextMap = {
      todo: 'doing',
      doing: 'review',
      review: 'done',
      done: 'todo'
    };
    const nextStatus = nextMap[task.status] || 'doing';
    if (onStatusChange) {
      onStatusChange(task.id, nextStatus);
    } else {
      await dataClient.update('tasks', task.id, {status: nextStatus});
    }
  }

  return (
    <article className="task-card">
      <div className="inline spread">
        <button
          type="button"
          className={`status ${task.status} status-clickable`}
          onClick={handleCycleStatus}
          title="Click to advance status"
        >
          {task.status}
        </button>
        {task.module && <small className="task-module-badge">{task.module}</small>}
      </div>

      <h4>{task.title}</h4>

      <div className="task-meta">
        <span>
          <SafeIcon icon={task.ownerType === 'bot' ? FiBot : FiUser} />
          {task.owner || 'Unassigned'}
        </span>
        <span>
          <SafeIcon icon={FiCalendar} />
          {task.due || task.due_date || 'No date'}
        </span>
      </div>

      {plan && dest && (
        <small className="task-plan-link-wrap">
          <SafeIcon icon={FiLink} />
          <Link to={dest} className="task-plan-link" title={`View source Plan: ${plan.title}`}>
            {plan.title}
          </Link>
        </small>
      )}
    </article>
  );
}

export function TaskList({tasks, plans, onStatusChange}) {
  return (
    <div className="task-list">
      {tasks.map((task) => (
        <TaskCard
          key={task.id}
          task={task}
          plan={plans.find((plan) => plan.id === task.planId)}
          onStatusChange={onStatusChange}
        />
      ))}
    </div>
  );
}
